import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const SentIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 14"
    sx={{ width: '20px', height: '14px', color: 'neutral400', ...sx }}
    {...props}
  >
    <path
      d="M7.50016 11.4167V11.5L15.8335 3.08333L14.8335 2L7.50016 9.33333L4.41683 6.25L3.3335 7.33333L7.50016 11.4167Z"
      fill="inherit"
    />
  </SvgIcon>
)

SentIcon.defaultProps = {
  sx: null,
}
